import { gql } from '@apollo/client'
import { SHELF_COMPLIANCE_GROUP_FRAGMENT } from './ShelfComplianceGroupFragment'

export const SEGMENT_COMPLIANCE_GROUP_FRAGMENT = gql`
  fragment SegmentComplianceGroup on SegmentComplianceGroup {
    id
    segment {
      segmentNumber
    }
    scanComplete
    strictScore
    sequenceScore
    shelfCompliance {
      ...ShelfComplianceGroup
    }
  }
  ${SHELF_COMPLIANCE_GROUP_FRAGMENT}
`
